export default __webpack_public_path__ + "static/media/web-color.627c3fcc.png";